import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { MultiTenantOrganizationClientLoadFulfilledAction } from '../../domains/multiTenantOrganization/actions.types';

import { MultiTenantOrganizationNetworks } from './types';

const initialState: MultiTenantOrganizationNetworks = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<MultiTenantOrganizationNetworks, MultiTenantOrganizationClientLoadFulfilledAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'MULTI_TENANT_ORGANIZATION.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities?.networks);
    default:
      return state;
  }
};

export default reducer;
